import { Link } from "react-router-dom";
import { LISTEN_ONLY_DEFAULT_SCENARIO_ID, SCENARIOS } from "@app/shared";

export function ScenarioListPage() {
  return (
    <div className="mx-auto max-w-md p-6">
      <h1 className="text-2xl font-semibold text-stone-800">
        今日はどの場面を練習しますか
      </h1>
      <p className="mt-2 text-sm text-stone-500">
        1回5分ほど。うまく話せなくて大丈夫です。
      </p>

      {/*
        声を出せる場所がないことが起動を止めている、という仮説への入口。
        生成りはヒントと同じ「助け舟」の色。シナリオより目立たせないこと。
        本編を食う懸念があるため、2回目以降にだけ出す案もある（未決）。
      */}
      <Link
        to={`/listen/${LISTEN_ONLY_DEFAULT_SCENARIO_ID}`}
        className="mt-6 block rounded-xl bg-[#f6f1e7] p-4"
      >
        <p className="text-base font-semibold text-stone-800">今日は聞くだけ</p>
        <p className="mt-1.5 text-[13px] leading-[1.6] text-stone-600">
          声を出しません。返し方を選ぶだけ。
          <br />
          30秒で終わります。
        </p>
        <p className="mt-2.5 text-[11px] text-stone-400">無料の回数は減りません</p>
      </Link>

      <ul className="mt-2.5 space-y-3">
        {SCENARIOS.map((s) => (
          <li key={s.id}>
            <Link
              to={`/talk/${s.id}`}
              className="block rounded-xl border border-stone-200 bg-white p-4 active:bg-stone-50"
            >
              <p className="font-medium text-stone-800">{s.title}</p>
              <p className="mt-1 text-sm text-stone-500">{s.situation}</p>
              <p className="mt-2 text-xs text-stone-400">
                相手：{s.partnerName}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
